import { createSelector } from 'reselect';
import { callSelectors, mediaSelectors } from '@lifesize/nucleus';
import _get from 'lodash/get';

const getRemoteStream = state => mediaSelectors.selectMedia(state)?.remoteStream;
const getMiniplayerMode = state => _get(state, 'app.inCallVideo.miniplayerMode');
export const isMiniPlayerOpenSelector = state => _get(state, 'app.miniPlayer.isMiniPlayerOpen');

const miniPlayer = createSelector([
  callSelectors.activeCallSelector,
  getRemoteStream,
  mediaSelectors.selectedVideoDevice,
  getMiniplayerMode,
    isMiniPlayerOpenSelector],
(activeCall, remoteVideoStream, selectedVideoDevice, miniplayerMode, isMiniPlayerOpen) => ({
  isAudioEnabled: !(_get(activeCall, 'isAudioMuted') || _get(activeCall, 'isMutedByServer')),
  isModerator: _get(activeCall, 'isModerator', false),
  isMutedByServer: _get(activeCall, 'isMutedByServer'),
  title: _get(activeCall, 'name'),
  startTime: _get(activeCall, 'startTime'),
  remoteVideoStream,
  miniplayerMode,
  localVideoDeviceId: _get(selectedVideoDevice, 'deviceId'),
  isMiniPlayerOpen
}));

export default miniPlayer;
